var _mask, _rect, _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconHistory02 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 23 22"
}, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "icon_history_02_svg__a",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("rect", {
  width: 15.75,
  height: 19.25,
  x: 5,
  y: 1,
  rx: 0.5
}))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 15.75,
  height: 19.25,
  x: 5,
  y: 1,
  fill: "#fff",
  stroke: "#000",
  strokeWidth: 2.4,
  mask: "url(#icon_history_02_svg__a)",
  rx: 0.5
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 6.563,
  cy: 14.063,
  r: 5.963,
  fill: "#fff",
  stroke: "#000",
  strokeWidth: 1.2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M7.5 11.125v4.432l-3.38 1.568-.62-1.148 2.616-1.213v-3.639z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeWidth: 1.2,
  d: "M10.255 6.3h6.995M13 9.3h4.25"
})));
export default SvgIconHistory02;